export const handleAjaxError = ( header_text, error ) => {

	let errorTemplate = `
			<p>${wpmdb_strings.ajax_php_errors}:</p>
			<p>${error.message}</p>
	`;

	wpmdb.current_migration.setState( header_text, errorTemplate, 'error' );
	wpmdb.common.migration_error = true;
	wpmdb.functions.migration_complete_events();
	console.error( '🚨 🚒', error );
	return;
};

export const throwMDBError = ( parsed_response ) => {
	let error_body;

	if ( undefined !== parsed_response.body ) {
		wpmdb.common.non_fatal_errors += parsed_response.body;
		error_body = parsed_response.body;
	}

	if ( undefined !== parsed_response.msg ) {
		error_body = parsed_response.msg;
	}

	throw new Error( error_body );
};

export const jQueryAjaxError = ( responseText, jqXHR ) => {
	if ( 'undefined' !== typeof jqXHR.responseText && '' !== jqXHR.responseText ) {
		responseText = jqXHR.responseText;
	} else if ( 'undefined' !== typeof jqXHR.statusText ) {
		responseText = jqXHR.statusText;
	}

	console.error( jqXHR );

	wpmdb.current_migration.setState( wpmdb_strings.migration_failed, responseText, 'error' );
	wpmdb.common.migration_error = true;
	wpmdb.functions.migration_complete_events();
	return responseText;
};

export const doNextStep = ( fn, args, instance ) => {
	wpmdb.common.next_step_in_migration = {
		fn: fn,
		args: args
	};

	return wpmdb.functions.execute_next_step( instance );
}



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/helpers/utils.js